// 水费缴费——微信，主流程
const wxMainRoutes = Array.from({ length: 15 }, (_, i) => ({
  path: `water/wx/index${i + 1}`,
  name: `waterWxIndex${i + 1}`,
  component: () => import(`@/views/life/water/wx/index${i + 1}.vue`)
}))

// 水费缴费——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 14 }, (_, i) => ({
  path: `water/zfb/index${i + 1}`,
  name: `waterZfbIndex${i + 1}`,
  component: () => import(`@/views/life/water/zfb/index${i + 1}.vue`),
}));

// 水费缴费——支付宝，分支1
const zfbBranch1Routes = Array.from({ length: 7 }, (_, i) => ({
  path: `water/zfb/branch1/index${i + 1}`,
  name: `waterZfbBranch1Index${i + 1}`,
  component: () =>
    import(`@/views/life/water/zfb/branch1/index${i + 1}.vue`),
}));

export default {
  path: '/life',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 水费缴费——微信，开始
    ...wxMainRoutes,

    // 水费缴费——支付宝，主流程
    ...zfbMainRoutes,
    // 水费缴费——支付宝，分支1
    ...zfbBranch1Routes


  ]
}
